export default __webpack_public_path__ + "static/media/logo.7de7c721.png";